import { Message } from 'dealer-types'
import React, { useEffect, useMemo, useRef } from 'react'
import Avatar from '../atoms/Avatar'
import View from '../atoms/View'
import Text from '../atoms/TextNew'
import Space from '../atoms/Space'

interface Props {
  messages: Message[]
  variant?: 'OfferMessage' | 'ConversationMessage'
}

const MessagesList = ({ messages, variant = 'ConversationMessage' }: Props): JSX.Element => {
  const containerRef = useRef<HTMLInputElement>(null)
  const safeMessages = useMemo(() => {
    return Array.isArray(messages) ? messages : []
  }, [messages])

  useEffect(() => {
    if (containerRef.current !== null) {
      containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
    }
  }, [containerRef, safeMessages])

  return (
    <div className="w-full overflow-scroll min-h-10 hide-scrollbar" style={{ maxHeight: window.innerHeight - 400 }}>
      {safeMessages.map(({ id, body, author, avatar, created_at }) => {
        const containerStyles = author === 'dealer' ? 'flex-row-reverse' : 'flex-row'
        const backgroundStyles = author === 'dealer' ? 'bg-white' : 'bg-lightGrey'
        const borderWidthStyles = author === 'dealer' ? 'border' : 'border-0'
        return (
          <View key={id} className={`flex ${containerStyles} my-2 `}>
            <Avatar type={author} imgSrc={avatar} variant={variant} />
            <Space x={2} />
            <View
              className={`flex flex-col justify-between gap-4 w-full ${backgroundStyles} ${borderWidthStyles} border-groupBlue rounded-4 p-4 min-h-[120px]`}>
              <Text className="text-darkGrey text-l">{body}</Text>
              <Text className="text-l">{created_at}</Text>
            </View>
            <Space x={1} />
          </View>
        )
      })}
      <div ref={containerRef}> </div>
    </div>
  )
}

export default MessagesList
